import { IonCol, IonImg, IonRow } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { RootState } from '../../../../../models/RootState';
import '../styles/main.scss';
import CardBack from '../../../../../assets/images/casino/cards/card-back.png';
import LockIcon from '../../../../../assets/images/casino/cards/lock.png';
import { INDIAN_CASINO_GAMES_MAP } from '../../../../../constants/IndianCasinoGames';
import {
  CasinoGameDTO,
  CasinoGameResultDTO,
  CasinoGmaeData,
} from '../../../../../models/IndianCasinoState';
import {
  fetchGameData,
  addExchangeBet,
  clearExchcngeBets,
  fetchCasinoOpenBets,
} from '../../../../../store';
import { BsData, PlaceBetRequest } from '../../../../../models/BsData';
import {
  subscribeWsForIndianCasino,
  subscribeWsForIndianCasinoGameResult,
  unsubscribeAllWsforEvents,
} from '../../../../../webSocket/webSocket';
import { UserBet } from '../../../../../models/UserBet';
import API from '../../../../../api';

type StoreProps = {
  casinoGames: CasinoGameDTO[];
  gameData: CasinoGmaeData;
  gameResults: CasinoGameResultDTO[];
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  fetchGameData: (gameCode: string) => void;
  clearExchcngeBets: () => void;
  addExchangeBet: (bets: PlaceBetRequest) => void;
  fetchCasinoOpenBets: (gType: string, mId: string) => void;
};

type RouteParams = {
  gameCode: string;
};

const Teenpatti2020Game: React.FC<StoreProps> = (props) => {
  const {
    casinoGames,
    gameData,
    gameResults,
    bets,
    openBets,
    fetchGameData,
    clearExchcngeBets,
    addExchangeBet,
    fetchCasinoOpenBets,
  } = props;
  const [gameSrc, setGameSrc] = useState<string>('');
  const [matchId, setMatchId] = useState<string>();
  const [minStake, setMinStake] = useState<number>(500);
  const [maxStake, setMaxStake] = useState<number>(50000);
  const [matchResult, setMatchResult] = useState<string>();
  const resultsMap = {
    '1': 'a',
    '3': 'b',
  };
  const disabledTimerValues = ['3', '2', '1', '0'];
  const { gameCode } = useParams<RouteParams>();

  const getGameUrl = async (gCode: string) => {
    setGameSrc(casinoGames.find((ic) => ic.id === gCode).streamURL);
  };

  const addBet = (cardNation: string) => {
    if (
      gameData.roundDetails.length > 0 &&
      !disabledTimerValues.includes(gameData.roundDetails[0].autotime)
    ) {
      const runner = gameData?.roundCardDetails.find(
        (r) => r.nation.toLowerCase() === cardNation
      );
      // const payload: BsData = {
      //   eventId: gameCode,
      //   eventName: casinoGames.find((ic) => ic.id === gameCode).name,
      //   marketId: gameData.mId,
      //   marketName: '-',
      //   oddsPrice: Number(runner.rate),
      //   casinoOdds: runner.rate,
      //   oddsSize: 100,
      //   betType: 'BACK',
      //   stake: 0,
      //   betType: 'CASINO',
      //   outcomeId: runner.sid,
      //   outcomeName: runner.nation,
      //   competitionId: '-',
      //   eventTypeId: INDIAN_CASINO_GAMES_MAP[gameCode],
      // };
      // addExchangeBet(payload);
    }
  };

  const getRiskValue = (sid: string) => {
    let risk = null;
    for (const bet of bets.filter((b) => b.outcomeId === sid)) {
      risk !== null ? (risk -= bet.amount) : (risk = 0 - bet.amount);
    }
    for (const bet of openBets.filter((b) => b.outcomeId === sid)) {
      risk !== null ? (risk -= bet.stakeAmount) : (risk = 0 - bet.stakeAmount);
    }
    return risk === 0 ? null : risk;
  };

  // const fetchBetLimits = async () => {
  //   try {
  //     const payload = {
  //       betLimitsType: 'SPORT',
  //       minStake: null,
  //       maxStake: null,
  //       category: 'INDIAN_CASINO',
  //       sportId: gameCode,
  //       competitionId: '-',
  //       eventId: '-',
  //       marketType: null,
  //       marketId: '-',
  //       sessionId: '-',
  //     };
  //     let response;
  //     if (sessionStorage.getItem('jwt_token')) {
  //       response = await API.post('/house/fetch-bet-limits', payload, {
  //         headers: {
  //           Authorization: sessionStorage.getItem('jwt_token'),
  //         },
  //       });
  //     } else {
  //       response = await API.post('/house/fetch-bet-limits', payload);
  //     }
  //     if (response.status === 200 && response.data.length !== 0) {
  //       const data = response.data;
  //       // Set gen min and max stakes
  //       setMinStake(data[0].minStake);
  //       setMaxStake(data[0].maxStake);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  useEffect(() => {
    unsubscribeAllWsforEvents();
    if (gameCode) {
      clearExchcngeBets();
      getGameUrl(gameCode);
      fetchGameData(INDIAN_CASINO_GAMES_MAP[gameCode]);
      subscribeWsForIndianCasino(gameCode);
      subscribeWsForIndianCasinoGameResult(gameCode);
      // fetchBetLimits();
    }
  }, [gameCode]);

  useEffect(() => {
    if (gameData?.mId !== matchId) {
      setMatchId(gameData.mId);
    }
    if (
      gameData?.roundDetails.length > 0 &&
      gameData.roundDetails[0].C1 !== matchResult
    ) {
      setMatchResult(gameData.roundDetails[0].C1);
    }
  }, [gameData]);

  useEffect(() => {
    if (gameCode && matchId) {
      fetchCasinoOpenBets(INDIAN_CASINO_GAMES_MAP[gameCode], matchId);
    }
  }, [gameCode, matchId, matchResult]);

  return (
    <div className="indian-casiono-game-ctn">
      <div className="indian-casino-iframe-ctn">
        <div className="section-title gradient-background">
          <span>20-20 Teenpatti</span>
          <span>
            Id:{' '}
            {gameData?.mId.includes('.')
              ? gameData?.mId.split('.')[1]
              : gameData?.mId}
          </span>
        </div>
        {gameData.roundDetails.length > 0 ? (
          <>
            <div className="game-result gradient-background-secondary teenpatti-2020-results">
              <div>
                <div className="label">Player A</div>
                {gameData?.roundDetails.length > 0 ? (
                  <div className="result-set">
                    {gameData.roundDetails[0].C1 === '1' ? (
                      <IonImg className="result-card" src={CardBack} alt="H" />
                    ) : (
                      <IonImg
                        className="result-card"
                        src={require(`../../../../../assets/images/casino/cards/${gameData.roundDetails[0].C1}.png`)}
                        alt={gameData.roundDetails[0].C1}
                      />
                    )}
                    {gameData.roundDetails[0].C2 === '1' ? (
                      <IonImg className="result-card" src={CardBack} alt="H" />
                    ) : (
                      <IonImg
                        className="result-card"
                        src={require(`../../../../../assets/images/casino/cards/${gameData.roundDetails[0].C2}.png`)}
                        alt={gameData.roundDetails[0].C2}
                      />
                    )}
                    {gameData.roundDetails[0].C3 === '1' ? (
                      <IonImg className="result-card" src={CardBack} alt="H" />
                    ) : (
                      <IonImg
                        className="result-card"
                        src={require(`../../../../../assets/images/casino/cards/${gameData.roundDetails[0].C3}.png`)}
                        alt={gameData.roundDetails[0].C3}
                      />
                    )}
                  </div>
                ) : null}
              </div>
              <div>
                <div className="label">Player B</div>
                {gameData?.roundDetails.length > 0 ? (
                  <div className="result-set">
                    {gameData.roundDetails[0].C4 === '1' ? (
                      <IonImg className="result-card" src={CardBack} alt="H" />
                    ) : (
                      <IonImg
                        className="result-card"
                        src={require(`../../../../../assets/images/casino/cards/${gameData.roundDetails[0].C4}.png`)}
                        alt={gameData.roundDetails[0].C4}
                      />
                    )}
                    {gameData.roundDetails[0].C5 === '1' ? (
                      <IonImg className="result-card" src={CardBack} alt="H" />
                    ) : (
                      <IonImg
                        className="result-card"
                        src={require(`../../../../../assets/images/casino/cards/${gameData.roundDetails[0].C5}.png`)}
                        alt={gameData.roundDetails[0].C5}
                      />
                    )}
                    {gameData.roundDetails[0].C6 === '1' ? (
                      <IonImg className="result-card" src={CardBack} alt="H" />
                    ) : (
                      <IonImg
                        className="result-card"
                        src={require(`../../../../../assets/images/casino/cards/${gameData.roundDetails[0].C6}.png`)}
                        alt={gameData.roundDetails[0].C6}
                      />
                    )}
                  </div>
                ) : null}
              </div>
            </div>
            <iframe
              src={gameSrc}
              className="indian-casino-iframe"
              title="Indian Casino"
              sandbox="allow-same-origin allow-forms allow-scripts allow-top-navigation allow-popups"
            ></iframe>
            <div className="game-timer">
              {gameData?.roundDetails?.length > 0
                ? gameData.roundDetails[0].autotime
                : 0}
            </div>
          </>
        ) : null}
      </div>
      {gameData?.roundCardDetails?.length > 0 ? (
        <div className="odds-view">
          <IonRow className="shaded-background">
            {gameData.roundCardDetails.length > 0
              ? gameData.roundCardDetails.map((r, idx) => (
                  <IonCol className="oc-sub-groups">
                    <div className="oc-rate">{r.rate}</div>
                    <div
                      className="oc-group"
                      onClick={() => addBet(r.nation.toLowerCase())}
                    >
                      {r.nation}
                    </div>
                    {disabledTimerValues.includes(
                      gameData.roundDetails[0].autotime
                    ) ? (
                      <div className="disabled">
                        <img src={LockIcon} alt="l" className="lock-img" />
                      </div>
                    ) : null}
                    <div className="risk">{getRiskValue(r.sid)}</div>
                  </IonCol>
                ))
              : null}
            <IonCol size="12">
              <div className="oc-limits">
                Min: {minStake > 999 ? Number(minStake / 1000) + 'K' : minStake}{' '}
                Max: {maxStake > 999 ? Number(maxStake / 1000) + 'K' : maxStake}
              </div>
            </IonCol>
          </IonRow>
        </div>
      ) : null}
      <div className="recent-results-ctn">
        <div className="section-title gradient-background">
          <span>Last Results</span>
          <span>View All</span>
        </div>
        <div className="recent-results">
          {gameResults.map((lr, idx) => (
            <span
              key={'recent-result-' + idx}
              className={'recent-result ' + resultsMap[lr.result]}
            >
              {resultsMap[lr.result]}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    casinoGames: state.indianCasino.casinoGames,
    gameData: state.indianCasino.gameData,
    gameResults: state.indianCasino.gameResults,
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    fetchGameData: (gameCode: string) => dispatch(fetchGameData(gameCode)),
    addExchangeBet: (data: PlaceBetRequest) => dispatch(addExchangeBet(data)),
    clearExchcngeBets: () => dispatch(clearExchcngeBets()),
    fetchCasinoOpenBets: (gType: string, mId: string) =>
      dispatch(fetchCasinoOpenBets(gType, mId)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Teenpatti2020Game);
